/** Промокоды рекламных кампаний: статусы, типы бонусов и строки использования (админка). */

/** Статус активации промокода пользователем (совпадает с UserPromoCodeStatus на бэкенде). */
export enum UserPromoCodeStatus {
    /** Активирован, ждёт события */
    Active = 0,
    /** Израсходован — бонус сработал */
    Redeemed = 1,
    /** Заменён другим промокодом до применения */
    Replaced = 2,
    /** Кампания закончилась до применения */
    Expired = 3,
}

export const UserPromoCodeStatusLabels: Record<UserPromoCodeStatus, string> = {
    [UserPromoCodeStatus.Active]: "Активен",
    [UserPromoCodeStatus.Redeemed]: "Израсходован",
    [UserPromoCodeStatus.Replaced]: "Заменён",
    [UserPromoCodeStatus.Expired]: "Истёк",
};

/** Какой бонус сработал (совпадает с PromoBonusType на бэкенде). */
export enum PromoBonusType {
    /** Сниженная комиссия на продажу */
    Sale = 0,
    /** Скидка на покупку */
    Purchase = 1,
    /** Бонус к депозиту */
    Deposit = 2,
}

export const PromoBonusTypeLabels: Record<PromoBonusType, string> = {
    [PromoBonusType.Sale]: "Комиссия на продажу",
    [PromoBonusType.Purchase]: "Скидка на покупку",
    [PromoBonusType.Deposit]: "Бонус к депозиту",
};

/**
 * Операция, на которую израсходован промокод: заказ (Sale, Purchase) — со ссылкой на карточку,
 * депозит — без ссылки (отдельной страницы депозита в админке нет).
 */
export function promoEntityLink(bonusType: PromoBonusType, entityId: number): { href?: string; label: string } {
    return bonusType === PromoBonusType.Deposit
        ? { label: `Депозит #${entityId}` }
        : { href: `/app/orders/${entityId}`, label: `Заказ #${entityId}` };
}

/** Активация промокода: условия на момент активации и что сработало (admin/AdCampaigns/promo-codes/list). */
export type AdminPromoCodeUsage = {
    id: number;
    userId: bigint | string;
    userName?: string | null;
    campaignId: number;
    campaignName: string;
    code: string;
    status: UserPromoCodeStatus;
    activatedAt: string;
    saleCommissionPercent?: number | null;
    purchaseDiscountPercent?: number | null;
    depositBonusPercent?: number | null;
    redeemedAt?: string | null;
    bonusType?: PromoBonusType | null;
    /** Id заказа (Sale, Purchase) или депозита (Deposit) */
    entityId?: number | null;
    /** Сумма операции, копейки */
    baseAmountKopecks?: number | null;
    /** Наши затраты на бонус, копейки */
    costKopecks?: number | null;
};

export type AdminPromoCodeUsagesResult = {
    total: number;
    items: AdminPromoCodeUsage[];
    page: number;
    count: number;
};

export type AdminPromoCodeUsagesRequest = {
    page: number;
    count: number;
    campaignId?: number;
    userId?: string;
    status?: UserPromoCodeStatus;
    bonusType?: PromoBonusType;
};

/** Промокод, израсходованный на заказ: покупателя (Purchase) или продавца (Sale). */
export type AdminOrderPromoCode = {
    promoCodeId: number;
    code: string;
    userId: bigint | string;
    bonusType: PromoBonusType;
    /** Скидка покупателю или недобор комиссии продавца, копейки */
    costKopecks: number;
};
